import React from 'react';

const InfoRecurso = ({ label, valor, quebra = false }) => {
    return (
        <div>
            <small>
                <strong>{label}: </strong>
                <span>{valor}</span>
            </small>
        </div>
    );
};

export default InfoRecurso;
